// extracted by mini-css-extract-plugin
module.exports = {"lottery":"Lottery_lottery___0mCl"};